import AuthController from "../Controller/AuthController"

const _publicParams = [
    "logged_in",
    "logged_in_at",
]

const LOCAL_STORAGE_KEY_PIN_LOGIN = "pinLogin"
class PinLogin {
    #listenerMap = new Map()
    #listenerWeakMap = new WeakMap()
    #data = {}
    constructor() {

    }
    init(app, data) {
        this.app = app
        this.#data = this.#getData()
    }
    #getPublicParams = (data) => {
        let publicParams = {}
        _publicParams.forEach(key => {
            publicParams[key] = data[key]
        })
        return publicParams
    }
    #setData = (data) => {
        this.#data = data
        localStorage.setItem(LOCAL_STORAGE_KEY_PIN_LOGIN, JSON.stringify(data))
        this.notifyAllListeners()
    }
    #getData = (extra = {}) => {
        return Object.assign(JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_PIN_LOGIN) || "{}"), extra)
    }
    logout = () => {
        return AuthController.pinLogout()
            .then(({isLoggedIn}) => {
                this.notifyAllListeners()
                return {isLoggedIn}
            })
    }
    login = async (merchantAdminId, pin) => {
        if (!merchantAdminId || !pin) {
            return Promise.reject("Invalid merchantAdminId or pin")
        }
        return AuthController.pinLogin(merchantAdminId, pin)
                .then(({isLoggedIn}) => {
                    this.notifyAllListeners()
                    return {isLoggedIn}
                })
    }
    addOnChangeListener = (context, callback, isWeakListener = false) => {
        if (isWeakListener) {
            this.#listenerWeakMap.set(context, callback)
        }
        else {
            this.#listenerMap.set(context, callback)
        }

        // After add listener, reply with data at least once
        setTimeout(() => {
            this.notifyListener(callback)
        }, 100);
    }
    removeOnChangeListener = (context) => {
        this.#listenerMap.delete(context)
    }
    notifyAllListeners = () => {
        for (let [key, callback] of this.#listenerMap) {
            this.notifyListener(callback)
        }
    }
    isLoggedIn = () => {
        if (AuthController.isPinLoginEnabled()) {
            return AuthController.getAuthData().pinLogin.isLoggedIn
        }

        // PinLogin module not enabled, default to loggedIn = true
        return true
    }
    notifyListener = (callback) => {
        callback({isLoggedIn: this.isLoggedIn()})
    }

    /**
     * Refresh internal data and notify listeners of change
     */
    refresh = () => {
        this.notifyAllListeners()
    }
}

export default new PinLogin;